// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

export default styled<any, Theme>('form')`
  display: flex;
  flex-direction: column;
  width: 100%;
  & > :last-child {
    margin-bottom: 1rem;
  }
`;
